import { motion } from "framer-motion";

export function SectionHeading({ number, eyebrow, title, description, align = "left" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 34 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`relative mb-12 max-w-4xl ${align === "center" ? "mx-auto text-center" : ""}`}
      data-testid={`section-heading-${number}`}
    >
      <span className="pointer-events-none absolute -top-10 left-0 font-display text-[7rem] leading-none text-white/[0.035] sm:text-[10rem]">
        {number}
      </span>
      <p className="eyebrow mb-4" data-testid={`section-eyebrow-${number}`}>{eyebrow}</p>
      <h2 className="font-display text-5xl uppercase leading-[0.88] tracking-tight text-slate-50 sm:text-6xl lg:text-7xl">
        {title}
      </h2>
      {description ? (
        <p className="mt-5 max-w-2xl text-base leading-8 text-slate-400 sm:text-lg">{description}</p>
      ) : null}
    </motion.div>
  );
}
